import { app } from '../../../app';
import { lazyLoad } from '../../../lib/lazy-load';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center', {
        url: '/sharing-center',
        redirectTo: 'company.sharing-center.shared-passwords',
        component: 'companySharingCenter',
        resolve: {
            prefetch,
            publicServicesWithSso$,
            publicServicesWithSsoAnd2FA$,
        },
    });
}

/** @ngInject */
function prefetch(publicServicesWithSso$, publicServicesWithSsoAnd2FA$) {
    publicServicesWithSso$.get();
    publicServicesWithSsoAnd2FA$.get();
}

/** @ngInject */
function publicServicesWithSso$($filter, PublicServices) {
    return lazyLoad(() => PublicServices.getAllPublicServicesThatSupportSSOFiltered())
        .map(items => {
            const custom = items.find(i => i.slug === 'other');
            custom.serviceName = 'Custom';
            return items;
        })
        .map(items => $filter('orderBy')(items, 'serviceName'))
}

/** @ngInject */
function publicServicesWithSsoAnd2FA$($filter, PublicServices) {
    return lazyLoad(() => PublicServices.getAllPublicServicesThatSupportSSOAnd2FAFiltered())
        .map(items => {
            const custom = items.find(i => i.slug === 'other');
            custom.serviceName = 'Custom';
            return items;
        })
        .map(items => $filter('orderBy')(items, 'serviceName'))
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/sharing-center.state.js